module.exports = __webpack_public_path__ + "img/arrow.7dc058f5.svg";